import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select as CleanSelect } from './../../components';
import { FormInput } from 'form/FormInput';

const Select: React.FC<React.ComponentPropsWithoutRef<typeof CleanSelect> & {
  name?: string;
  state?: FormInput['state'];
  style?: React.CSSProperties;
}> = ({ name, state, style, ...props }) => {
  const { control } = useFormContext<any>();

  if (!name) {
    throw new Error('Name not provided');
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CleanSelect
          {...field}
          {...props}
          state={state}
          style={style}
          onSearchInputBlur={(e) => {
            if (props.onSearchInputBlur) {
              props.onSearchInputBlur(e);
            }
            setTimeout(field.onBlur, 100);
          }}
          onOptionClick={(option, key) => {
            if (props.onOptionClick) {
              props.onOptionClick(option, key);
            }
            field.onBlur();
          }}
        />
      )}
    />
  );
};

export default Select;
